import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import { SHOPIFY, INSURANCE } from '@/helpers/constants/Bundles';
import { normalizeKey } from '@/helpers';
import moment from 'moment';
let PendingOrderReminder = class PendingOrderReminder extends Mixins() {
    constructor() {
        super(...arguments);
        this.message = '';
        this.requestOnProcess = false;
        this.btnLabel = '';
    }
    get isTodayEqualToStartDate() {
        const today = moment().startOf('day');
        const startDate = moment(this.reminderDates?.start_date).startOf('day');
        if (today.isSame(startDate, 'day')) {
            this.btnLabel = 'Enable Xendit Now';
            return true;
        }
        this.btnLabel = 'Activate Xendit Now';
        return false;
    }
    get isTodayGreaterThanEndDate() {
        const today = moment().startOf('day');
        const endDate = moment(this.reminderDates?.end_date).startOf('day').add(1, 'day');
        ;
        if (today.isSame(endDate, 'day')) {
            this.btnLabel = 'Enable Xendit Now';
            return true;
        }
        this.btnLabel = 'Activate Xendit Now';
        return false;
    }
    get title() {
        if (this.isTodayEqualToStartDate) {
            return '⚠️ Important Notice: Maya Online Payment Gateway Will Be Disabled in 30 Days';
        }
        if (this.isTodayGreaterThanEndDate) {
            return 'Maya Payment Gateway Disabled';
        }
        return 'Maya Online Payment Gateway Disabling Soon!';
    }
    get endDate() {
        const startDate = new Date(this.reminderDates?.end_date);
        const fullDate = startDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return fullDate;
    }
    get bundle() {
        return normalizeKey(this.bundleKey || '');
    }
    get bundleKey() {
        const { key } = this.currentRoute.params;
        return key;
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    goToPaymentManager() {
        const shopifyKey = normalizeKey(SHOPIFY).toLowerCase();
        const insurance = normalizeKey(INSURANCE).toLowerCase();
        const key = this.bundle.toLowerCase();
        this.$emit('onClose');
        if (key === shopifyKey) {
            return this.$router.push({
                name: 'shopify-payment',
            });
        }
        if (key === insurance) {
            return this.$router.push({
                name: 'insurance-payment',
            });
        }
        return this.$router.push({
            name: 'ecommerce-payment',
        });
    }
};
__decorate([
    Prop({ type: Object, default: null })
], PendingOrderReminder.prototype, "reminderDates", void 0);
PendingOrderReminder = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], PendingOrderReminder);
export default PendingOrderReminder;
